module.exports = __webpack_public_path__ + "static/media/animated-ca.d50d1767.gif";